<div class="duplicate-policy" [formGroup]="duplicatePolicyFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="duplicate-policy-header">
    <div class="title">
      {{ 'policyPage.duplicatePolicy' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="duplicate-policy-body">
    <div class="input">
      <input [placeholder]="'policyPage.enterPolicyName' | labelsProvider" type="text" formControlName="policyName" />
    </div>
    <div class="drop-down-field">
      <app-select
        class="policy-field-box"
        placeHolder="Policy Type"
        [options]="policyTypes"
        (optionOnSelection)="onPolicyTypeSelection($event)"
      >
      </app-select>
    </div>

    <div class="duplicate-policy-body-description">
      {{ 'policyPage.duplicationMessage' | labelsProvider }}
    </div>
  </div>
  <div class="duplicate-policy-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': duplicatePolicyFormGroup.invalid || waitingForResponse,
      }"
      (click)="duplicatePolicy()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">{{ 'common.duplicate' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
